import * as yup from 'yup'
import { EMAIL_REGEX } from '_/utils/constants'

const CPF_REGEX = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
const REQUIRED_EMAIL_FIELDS_MESSAGE = 'Campo obrigatório'

function requireWhenSendEmailIsActive(schema) {
  return schema.test(
    'required-when-send-email-is-active',
    REQUIRED_EMAIL_FIELDS_MESSAGE,
    function validateRequiredWhenSendEmailIsActive(value) {
      if (!this.parent?.sendEmail) return true
      return ![undefined, null, ''].includes(value)
    }
  )
}

export const createAndEditReferaUsersFormSchema = yup.object().shape({
  name: yup.string().required('Campo obrigatório').max(255, 'Máximo de 255 caracteres'),
  cpf: yup.string().required('Campo obrigatório').matches(CPF_REGEX, 'CPF inválido'),
  email: yup.string().matches(EMAIL_REGEX, 'E-mail inválido').required('Campo obrigatório'),
  digisacUserId: yup.string().nullable(),
  sendEmail: yup.boolean().default(false),
  emailProvider: requireWhenSendEmailIsActive(yup.string().nullable()),
  smtpAddress: requireWhenSendEmailIsActive(yup.string().nullable()),
  smtpPort: requireWhenSendEmailIsActive(
    yup
      .number()
      .transform((value, originalValue) => (originalValue === '' ? null : value))
      .typeError('Porta SMTP deve ser um número')
      .integer('Porta SMTP deve ser um número inteiro')
      .min(1, 'Porta SMTP inválida')
      .max(65535, 'Porta SMTP inválida')
      .nullable()
  ),
  encryptionMethod: requireWhenSendEmailIsActive(yup.string().nullable()),
  emailConfigUsername: requireWhenSendEmailIsActive(yup.string().nullable()),
  emailConfigPassword: requireWhenSendEmailIsActive(yup.string().nullable()),
})

export const EMAIL_PROVIDER_OPTIONS = [{ label: 'Gmail', value: 'gmail' }]

export const ENCRYPTION_METHOD_OPTIONS = [{ label: 'TLS', value: 'tls' }]

export const SELECT_MENU_PROPS = {
  getContentAnchorEl: null,
  anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
  transformOrigin: { vertical: 'top', horizontal: 'center' },
}

export function applyCPFMask(input) {
  const pattern = /(\d{3})(\d{3})(\d{3})(\d{2})/
  return input.replace(pattern, '$1.$2.$3-$4')
}
